import React from "react";
import classes from './Tag.module.scss'
import PropTypes from "prop-types";
import TagNurse from "../TagNurse/TagNurse";


const Tag = ({label, type, onClick}) => {
  const handleOnClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  }
  const css = classes[type || 'yellow'];
  return (
    <span className={`${classes['tag']} ${css}`.trim()} onClick={handleOnClick}>{label}</span>
  );
};

Tag.propTypes = {
  type: PropTypes.oneOf(['yellow', 'orange', 'green', 'blue']),
  onClick: PropTypes.func,
  label: PropTypes.string,
};

Tag.defaultProps = {
  type: 'primary',
  onClick: () => {},
  label: ''
};

export default Tag;
